import { Component } from "react";
import Uppy from '@uppy/core'
import { DashboardModal } from '@uppy/react'
import Transloadit from '@uppy/transloadit';
import GoogleDrive from '@uppy/google-drive';
import Instagram from '@uppy/instagram';
import Url from '@uppy/url';
import Webcam from '@uppy/webcam';
import $ from 'jquery'

import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import { UPPY_AWS_KEY, UPPY_AWS_SECRET_KEY, UPPY_BUCKET, UPPY_BUCKET_URL, UPPY_CAMPAION_URL, UPPY_KEY } from "../../../../../actions/constant";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";

const uppyKey = UPPY_KEY;
const uppyBucket =  UPPY_BUCKET;
const uppyAwsKey =  UPPY_AWS_KEY;
const uppyAwsSecret =  UPPY_AWS_SECRET_KEY;
const companionUrl = UPPY_CAMPAION_URL;

class ImageUpload extends Component {

    constructor(props) {
        super(props)

        this.uppyPostEdit = new Uppy({ debug: true, autoProceed: false, allowMultipleUploadBatches: false,restrictions: { maxFileSize: 5000000, maxNumberOfFiles: 1, minNumberOfFiles: 1, allowedFileTypes: ['image/*'] } })
            .use(Transloadit, {
                target: '#a',
                params: {
                    auth: {
                        key: uppyKey
                    },
                    steps: {
                        resize: {
                            robot: '/image/resize',
                            width: 500,
                            resize_strategy: 'fit',
                            background: 'none',
                        },
                        store: {
                            robot: "/wasabi/store",
                            bucket_region: "us-west-1",
                            bucket: uppyBucket,
                            key: uppyAwsKey,
                            secret: uppyAwsSecret,
                            path: `media/${localStorage.getItem('loginOwnerId')}/profile/`+'${file.id}'
                        }
                    }
                },
                waitForEncoding: true
            })
            .use(Instagram, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(GoogleDrive, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(Url, { target: Uppy.Dashboard, companionUrl: companionUrl })
            .use(Webcam, { target: Uppy.Dashboard, companionUrl: companionUrl })



        this.onClickToOpen = this.onClickToOpen.bind(this)
        this.onClickToClose = this.onClickToClose.bind(this)
    }
    state = {
        filename: null,
        modalOpen: false,
        selected: "",
        renderKey: 0
    }

    componentDidMount() {

        this.uppyPostEdit.on('transloadit:result', (stepName, result) => {
            this.setState({ selectedFile: result.id, filename: `${UPPY_BUCKET_URL}media/${localStorage.getItem('loginOwnerId')}/profile/${result.id}`, selected: `${UPPY_BUCKET_URL}media/${localStorage.getItem('loginOwnerId')}/profile/${result.id}` }, () => {
                setTimeout(() => {
                    this.uppyPostEdit.cancelAll()
                    this.props.onImgUpload(`${UPPY_BUCKET_URL}media/${localStorage.getItem('loginOwnerId')}/profile/${result.id}`)
                    this.setState({ modalOpen: false })
                }, 300)
            })

        })
    }

    onClickToOpen = () => {

        this.setState({ modalOpen: true })
        $(".uppy-Dashboard-close").click(() => {
            this.uppyPostEdit.cancelAll()
            this.setState({ modalOpen: false })
        })
    }
    onClickToClose = () => {
        this.uppyPostEdit.cancelAll()
        this.setState({ modalOpen: false, renderKey: Math.floor(Math.random() * 6) + 1 })
    }
    componentWillUnmount() {
        this.uppyPostEdit.cancelAll()
        this.uppyPostEdit.close({ reason: 'unmount' })
        this.setState({ modalOpen: false, renderKey: Math.floor(Math.random() * 6) + 1 })
    }


    render() {
        const { modalOpen, renderKey } = this.state;
    
        return (
            <div key={renderKey}>
                <Button variant="light" id="drag-drop-area" className="p-0 border-0 rounded-circle h-24px w-24px shadow bg-white btn-link" onClick={() => this.onClickToOpen()}>
                    <FontAwesomeIcon type={'solid'} icon={'pencil'} iconClass={'fs-6 text-muted'}/>
                </Button>

                <DashboardModal
                    animateOpenClose={true}
                    proudlyDisplayPoweredByUppy={false}
                    inline={false}
                    open={modalOpen}
                    showProgressDetails={true}
                    height={750}
                    browserBackButtonClose={true}
                    showRemoveButtonAfterComplete={false}
                    uppy={this.uppyPostEdit}
                    onRequestCloseModal={this.onClickToClose}
                    closeAfterFinish={true}
                    doneButtonHandler={this.doneButtonHandler}
                    plugins={["Instagram", "GoogleDrive", "Url", "Webcam"]}
                />
            </div>
        );
    }
}

export default ImageUpload;
